import { render, staticRenderFns } from "./ToolSettingsHeatmap.vue?vue&type=template&id=f9dfe33a&scoped=true&"
import script from "./ToolSettingsHeatmap.vue?vue&type=script&lang=js&"
export * from "./ToolSettingsHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9dfe33a",
  null
  
)

export default component.exports